<ion-refresher-content [refreshingSpinner]="null">
  <div class="ion-infinite-custom-loader" *ngIf="isRefreshing">
    <ion-icon src="./assets/icon/Loader.svg"></ion-icon>
  </div>
</ion-refresher-content>
